import React, { useState } from 'react';
import { Card, message } from 'antd';
import {
    DesktopOutlined,
    LoadingOutlined,
    VideoCameraOutlined,
    FilePptOutlined,
} from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { storeContentVideoDownloadLog } from '../../redux/dashboard/actionCreator';
import './TopMetricsSection.css';

const TVPanelCard = ({ storeContentVideoDetailsData }) => {
    const dispatch = useDispatch();
    const [downloadingVideo, setDownloadingVideo] = useState(false);
    const [downloadingFile, setDownloadingFile] = useState(false);
    const videoDetails = storeContentVideoDetailsData?.data?.video_details || {};

    const handleDownloadContent = async (type) => {
        const unique = type === 'document' ? videoDetails.icon_link : videoDetails.video_link;

        if (!unique) {
            message.error(type === 'document' ? 'Document link is not available' : 'Video link is not available');
            return;
        }

        if (type === 'document') {
            setDownloadingFile(true);
        } else {
            setDownloadingVideo(true);
        }

        try {
            const response = await dispatch(storeContentVideoDownloadLog({ unique, type }));
            if (response?.status === true && response?.data) {
                const link = document.createElement('a');
                link.href = response.data;
                link.download = '';
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                message.error(response?.message || 'Unable to download content');
            }
        } catch (error) {
            message.error('Unable to download content');
        } finally {
            if (type === 'document') {
                setDownloadingFile(false);
            } else {
                setDownloadingVideo(false);
            }
        }
    };

    return (
        <Card
            className="top-metrics-card media-action-card"
            styles={{
                body: {
                    padding: '20px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                },
            }}
        >
            <div className="media-action-content">
                <div className="card-header-flex" style={{ marginBottom: 12 }}>
                    <div className="card-header-left">
                        <div className="card-header-icon icon-emerald-grad">
                            <DesktopOutlined />
                        </div>
                        <div className="card-header-titles">
                            <h3 className="card-main-title">TV Panel</h3>
                        </div>
                    </div>
                </div>

                <div className="media-tiles-grid">
                    <div
                        className="media-tile-simple media-tile-simple-video"
                        onClick={() => handleDownloadContent('video')}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                handleDownloadContent('video');
                            }
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        <div className="media-tile-avatar avatar-rose">
                            {downloadingVideo ? <LoadingOutlined /> : <VideoCameraOutlined />}
                        </div>
                        <span className="media-simple-title">Videos</span>
                    </div>

                    <div
                        className="media-tile-simple media-tile-simple-file"
                        onClick={() => handleDownloadContent('document')}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                handleDownloadContent('document');
                            }
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        <div className="media-tile-avatar avatar-blue">
                            {downloadingFile ? <LoadingOutlined /> : <FilePptOutlined />}
                        </div>
                        <span className="media-simple-title">Document</span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default TVPanelCard;
